/*
 * © Copyright 2014 – 2023 Open Text or one of its affiliates.
 *
 * The only warranties for products and services of Open Text and its affiliates and licensors ("Open Text") are as
 * may be set forth in the express warranty statements accompanying such products and services. Nothing herein should be
 * constituting an additional warranty. Open Text shall not be liable for technical or editorial errors or omissions
 * contained herein.
 *
 * The information contained herein is subject to change without notice.
 */

import PropTypes from 'prop-types';

// Categories
const categoryType = PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired
});
export const categoriesType = PropTypes.arrayOf(categoryType);

// Template
const templateShape = {
    comment: PropTypes.string,
    isEnrolled: PropTypes.bool.isRequired,
    isFullyEnrolled: PropTypes.bool.isRequired,
    methodId: PropTypes.string.isRequired,
    methodTitle: PropTypes.string.isRequired
};

const availableTemplateShape = Object.assign({
    availableCategoryIds: PropTypes.arrayOf(PropTypes.string).isRequired
});

const enrolledTemplateShape = Object.assign({
    categoryId: PropTypes.string,
    id: PropTypes.string.isRequired
}, templateShape);

const requiredMethodShape = Object.assign({
    id: PropTypes.string,
    title: PropTypes.string
});

export const templateType = PropTypes.shape(templateShape);
export const availableTemplateType = PropTypes.shape(availableTemplateShape);
export const enrolledTemplateType = PropTypes.shape(enrolledTemplateShape);

export const requiredMethodType = PropTypes.shape(requiredMethodShape);
export const requiredMethodsType = PropTypes.arrayOf(requiredMethodType);
export const requiredMethodsTemplatesType = PropTypes.objectOf(requiredMethodType)

export const availableIndexedTemplatesType = PropTypes.objectOf(availableTemplateType);
export const enrolledTemplatesType = PropTypes.arrayOf(enrolledTemplateType);
export const enrolledIndexedTemplatesType = PropTypes.objectOf(enrolledTemplatesType);

// Chain
const methodType = PropTypes.shape({
    id: PropTypes.string.isRequired,
    isEnrolled: PropTypes.bool.isRequired
});

const chainShape = {
    idHex: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    methods: PropTypes.arrayOf(methodType).isRequired,
};

const indexedChainShape = Object.assign({
    categoryId: PropTypes.string.isRequired,
    categoryName: PropTypes.string.isRequired,
    chainUris: PropTypes.arrayOf(PropTypes.string).isRequired,
    isEnrolled: PropTypes.bool.isRequired,
    templates: PropTypes.arrayOf(templateType).isRequired
}, chainShape);

export const indexedChainType = PropTypes.shape(indexedChainShape);
export const indexedChainsType = PropTypes.objectOf(PropTypes.arrayOf(indexedChainType));
